import ApiClient from '../ApiClient';

class KanbanBoardsAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }
}

export default new KanbanBoardsAPI();
